import { useMutation } from 'react-query';
import { AssuranceType, GeneralInformation } from './assessmentTypes';
import { changeQaType } from './assessmentService';
import { toast } from 'react-toastify';
import { modifyError } from 'utils/error-modifer-utils';

type Props = {
    onError?: (error: Error) => void;
    onSuccess?: (data: GeneralInformation) => void;
};

export const useChangeQaType = ({
    onSuccess = () => {},
    onError = () => {},
}: Props) => {
    const onErrorModified = (error: any) => {
        const errors = modifyError(error?.response?.data);
        if (errors) {
            for (const err of errors) {
                toast.error(err);
            }
        } else {
            toast.error('Internal error, please contact administrator');
        }

        if (onError) {
            onError(error);
        }
    };
    const mutation = useMutation(
        async (input: { id: string; qaType: AssuranceType }) =>
            await changeQaType(input.id, input.qaType),
        {
            onSuccess,
            onError: onErrorModified,
        }
    );

    return {
        mutate: mutation.mutate,
        mutateAsync: mutation.mutateAsync,
        isLoading: mutation.isLoading,
        error: mutation.error,
    };
};
